import {Module} from "wrapper6";

var $ = jQuery;

export default class ShareButtons extends Module {

    ready(app) {
        $( document ).ready(function() {

            var container = $('.share-button');
            var wrapper = $('.share-button-wrapper');

            $(window).click(function(e) {
                if(!container.is(e.target) && container.has(e.target).length === 0 && !wrapper.is(e.target) && wrapper.has(e.target).length === 0) {
                    $('.share-button-wrapper').stop().slideUp();
                }
            });

            container.click(function() {
                wrapper.stop().slideToggle();
            });

            $(document).on('click', '.share-button-wrapper a', {}, function popUp(e) {
                var self = $(this);



                if (self.attr('href').indexOf('mailto:') === -1) {
                    popupCenter(self.attr('href'), self.find('.rrssb-text').html(), 580, 470);
                    e.preventDefault();
                }
            });

            var popupCenter = function(url, title, w, h) {
                // Fixes dual-screen position                         Most browsers      Firefox
                var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
                var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

                var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
                var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

                var left = ((width / 2) - (w / 2)) + dualScreenLeft;
                var top = ((height / 3) - (h / 3)) + dualScreenTop;

                var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

                // Puts focus on the newWindow
                if (newWindow && newWindow.focus) {
                    newWindow.focus();
                }
            };

        });
    }

}